import {REQUEST_STATUS_KEY_TYPE, REQUEST_TYPE_KEY_TYPE} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	requestId: z.string().nullable().default(""),
	managerDepartment: z.string().nullable().default("UNKNOWN"),
	managerName: z.string().nullable().default(""),
	taxAccountantName: z.string().nullable().default(""),
	requestType: REQUEST_TYPE_KEY_TYPE.nullable().default("INSERT"),
	requestStatus: REQUEST_STATUS_KEY_TYPE.nullable().default("PENDING"),
	requestedAt: z.string().nullable().default("")
});

const model = schema.transform((values) => ({
	...values
}));

export const RequestResModel = {schema, model};
export type IRequestResModel = z.infer<typeof RequestResModel.model>;
export const DEFAULT_REQUEST_RES: IRequestResModel = {
	requestId: "",
	managerDepartment: "UNKNOWN",
	managerName: "",
	taxAccountantName: "",
	requestType: "INSERT",
	requestStatus: "PENDING",
	requestedAt: ""
};
